class InsuranceAddon {
  constructor(container) {
    this.container = container;
    this.bundleInput = container.querySelector('[data-insurance-bundle-input]');
    this.planInputs = Array.from(container.querySelectorAll('[data-js-insurance-plan]'));
    this.productForm = document.getElementById(container.dataset.productFormId);

    this.planInputs.forEach((input) => {
      input.addEventListener('change', () => this.onPlanChange(input));
    });
  }

  onPlanChange(input) {
    this.planInputs.forEach((planInput) => {
      if (planInput !== input) planInput.checked = false;
    });

    this.bundleInput.checked = false;
    this.bundleInput.disabled = true;
    this.bundleInput.value = '';
    this.bundleInput.dataset.price = '';

    if (input.checked) {
      this.bundleInput.value = input.dataset.variantId;
      this.bundleInput.dataset.price = input.dataset.price;
      this.bundleInput.disabled = false;
      this.bundleInput.checked = true;
    }

    this.dispatchBundleChange();
  }

  dispatchBundleChange() {
    if (!this.productForm) return;

    const items = this.bundleInput.checked && !this.bundleInput.disabled
      ? [{
          id: this.bundleInput.value,
          quantity: 1,
          price: this.bundleInput.dataset.price
        }]
      : [];

    this.productForm.dispatchEvent(new CustomEvent('bundle:change', { detail: { items } }));
  }
}

const initInsuranceAddons = (scope = document) => {
  scope.querySelectorAll('[data-js-insurance]:not([data-insurance-ready])').forEach((container) => {
    container.dataset.insuranceReady = 'true';
    new InsuranceAddon(container);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initInsuranceAddons(), { once: true });
} else {
  initInsuranceAddons();
}

document.addEventListener('shopify:section:load', (event) => initInsuranceAddons(event.target));
